/**
 * This method is behind support checks and shouldn't be used outside of those.
 */
export function createBroadcastMessageChannels({
  portalId,
  channelName,
  version,
  onMessageError
}) {
  // eslint-disable-next-line compat/compat
  const toWorkerChannel = new BroadcastChannel(`${channelName}-to-worker-${version}-${portalId}`);
  // eslint-disable-next-line compat/compat
  const fromWorkerChannel = new BroadcastChannel(`${channelName}-from-worker-${version}-${portalId}`);
  toWorkerChannel.onmessageerror = messageErrorEvent => {
    const messageData = messageErrorEvent && messageErrorEvent.data ? messageErrorEvent.data : {};
    onMessageError(new Error(`Message Error in toWorkerChannel Broadcast Channel`), {
      messageData
    });
  };
  fromWorkerChannel.onmessageerror = messageErrorEvent => {
    const messageData = messageErrorEvent && messageErrorEvent.data ? messageErrorEvent.data : {};
    onMessageError(new Error(`Message Error in fromWorkerChannel Broadcast Channel`), {
      messageData
    });
  };
  return {
    toWorkerChannel,
    fromWorkerChannel
  };
}